import { ThemeId } from '@stadionhq-v3/core';
import { PromoCarouselProps } from '@stadionhq-v3/base-ui';
import { Link, PromoCarouselBlock } from '@graphql/__generated__/graphql';
import { Locale } from '@core/constants/locales.constants';
import { isRtlLocale } from '@utils/locales.utils/locales.utils';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { ContentfulImage } from '@stadionhq-v3/contentful-ui';
import { Translations } from '@lib/dictionary-keys/__generated__';
import PromoCard from '@components/v3/molecules/promo-card';
import { ChevronLeft, ChevronRight } from '@components/icons';
import { linkTransform } from '../atoms';

const promoCarouselBlockTransform = (
  {
    promoCarouselTitle,
    subTitle,
    carouselCards,
    callToActionLink,
    theme,
  }: CleanContentful<PromoCarouselBlock>,
  locale: Locale,
  dictionary: {
    previous: Translations['common']['action']['previous'];
    next: Translations['common']['action']['next'];
  }
): PromoCarouselProps => ({
  title: promoCarouselTitle || '',
  subTitle: subTitle || '',
  cards: carouselCards
    ?.filter(Boolean)
    .map((card) => (
      <PromoCard
        key={card?.id}
        title={card?.promoTitle || ''}
        summary={card?.summary || ''}
        subTitle={card?.label || ''}
        image={card?.image && <ContentfulImage {...card.image} />}
        link={card?.link?.url ? linkTransform(card?.link, locale) : undefined}
      />
    )),
  link: callToActionLink?.url
    ? linkTransform(callToActionLink as CleanContentful<Link>, locale)
    : undefined,
  theme: {
    themeId: theme?.themeId as ThemeId,
    title: theme?.title as string,
  },
  previousButton: {
    text: dictionary.previous,
    iconBefore: isRtlLocale(locale) ? <ChevronRight /> : <ChevronLeft />,
  },
  nextButton: {
    text: dictionary.next,
    iconBefore: isRtlLocale(locale) ? <ChevronLeft /> : <ChevronRight />,
  },
  options: {
    direction: isRtlLocale(locale) ? 'rtl' : 'ltr',
  },
});

export default promoCarouselBlockTransform;
